import { MapPin, Clock, Shield, Sparkles, Droplets, Hand, CloudSun } from "lucide-react";

const REASONS = [
  {
    icon: MapPin,
    title: "Newcastle Local",
    body: "Born and based in Newcastle, NSW. We know the suburbs, the streets, and what your car deals with daily.",
  },
  {
    icon: Hand,
    title: "We Come To You",
    body: "Driveway, office, apartment block — we set up where you are. You skip the queue at the carwash.",
  },
  {
    icon: Sparkles,
    title: "Precision By Hand",
    body: "No tunnels, no swirl marks. Every panel is hand-washed with the two-bucket method and soft microfibres.",
  },
  {
    icon: CloudSun,
    title: "Weather-Wise & Flexible",
    body: "We're fully mobile, so weather calls the shots. That's why we don't take strict pre-bookings — give us a call and we'll lock in the best window for your car.",
  },
  {
    icon: Shield,
    title: "Pro Products Only",
    body: "PH-balanced soaps, premium sealants, and trusted interior care — safe for paint, leather and trim.",
  },
  {
    icon: Droplets,
    title: "Eco-Aware",
    body: "Water-smart wash methods and biodegradable products that respect your driveway and the storm drain.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative bg-[#0b0b0e] py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-display text-xs uppercase tracking-[0.3em] text-[#E10600] mb-3">
              / Why Rapid Shine
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter text-white">
              The detail
              <br />
              is in the <span className="text-[#E10600]">detail.</span>
            </h2>
            <p className="mt-6 font-body text-zinc-400 max-w-md leading-relaxed">
              We&apos;re a small, sharp Newcastle outfit who treat every vehicle
              like it&apos;s our own. No franchise checklist energy — just real
              care, real results, and a clean car every single time.
            </p>
          </div>

          <div className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
            {REASONS.map((r, i) => {
              const Icon = r.icon;
              return (
                <div
                  key={r.title}
                  data-testid={`why-card-${i}`}
                  className="group relative p-6 rounded-2xl bg-zinc-900/60 border border-white/10 hover:border-[#E10600]/40 transition-colors"
                >
                  <div className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-[#E10600]/10 border border-[#E10600]/20 mb-4">
                    <Icon className="w-5 h-5 text-[#E10600]" />
                  </div>
                  <div className="font-display text-xl uppercase font-bold tracking-tight text-white">
                    {r.title}
                  </div>
                  <p className="mt-2 font-body text-sm text-zinc-400 leading-relaxed">
                    {r.body}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
